export const UserIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.501 8C12.1578 8 13.501 6.65685 13.501 5C13.501 3.34315 12.1578 2 10.501 2C8.84412 2 7.50098 3.34315 7.50098 5C7.50098 6.65685 8.84412 8 10.501 8Z"
        fill={color}
      />
      <path
        d="M3.96615 14.4935C3.77126 15.0016 3.94533 15.571 4.37518 15.9046C6.06753 17.218 8.19299 18 10.5011 18C12.8115 18 14.939 17.2164 16.6322 15.9006C17.0618 15.5667 17.2355 14.9971 17.0403 14.4892C16.031 11.8635 13.4852 10 10.504 10C7.52129 10 4.97427 11.8656 3.96615 14.4935Z"
        fill={color}
      />
    </svg>
  )
}

export const InformationIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75153 5H9.87305L9.875 5H12.6915C14.2429 5.00223 15.4999 6.26058 15.4999 7.8125V15.625C16.8806 15.625 17.9999 14.5057 17.9999 13.125V5.09018C17.9999 3.83568 17.0626 2.74717 15.7799 2.6407C15.5934 2.62522 15.4066 2.61101 15.2194 2.59806C14.8028 1.79706 13.9653 1.25 13 1.25H11.75C10.7847 1.25 9.94723 1.79706 9.53064 2.59804C9.34339 2.611 9.15649 2.62522 8.96995 2.6407C7.71804 2.74461 6.79518 3.78391 6.75153 5ZM11.75 2.5C11.0596 2.5 10.5 3.05964 10.5 3.75H14.25C14.25 3.05964 13.6904 2.5 13 2.5H11.75Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7.8125C3 6.94956 3.69956 6.25 4.5625 6.25H12.6875C13.5504 6.25 14.25 6.94956 14.25 7.8125V17.1875C14.25 18.0504 13.5504 18.75 12.6875 18.75H4.5625C3.69956 18.75 3 18.0504 3 17.1875V7.8125ZM10.988 11.6404C11.2037 11.3709 11.16 10.9776 10.8904 10.762C10.6209 10.5463 10.2276 10.59 10.012 10.8596L7.94817 13.4393L7.19194 12.6831C6.94786 12.439 6.55214 12.439 6.30806 12.6831C6.06398 12.9271 6.06398 13.3229 6.30806 13.5669L7.55806 14.8169C7.68377 14.9426 7.85706 15.0089 8.03456 14.999C8.21207 14.9892 8.37699 14.9043 8.48804 14.7654L10.988 11.6404Z"
        fill={color}
      />
    </svg>
  )
}

export const BrushIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4932 1.38468C16.8195 1.13518 17.2188 1 17.6295 1C18.6626 1 19.5002 1.83751 19.5002 2.87063C19.5002 3.28136 19.365 3.68067 19.1155 4.00694L15.0856 9.27674C13.9464 10.7666 12.4978 11.9799 10.849 12.839C10.4356 11.2868 9.21335 10.0645 7.66113 9.6512C8.52023 8.00236 9.73359 6.5538 11.2234 5.41453L16.4932 1.38468Z"
        fill={color}
      />
      <path
        d="M6.49977 11C4.84292 11 3.49977 12.3431 3.49977 14C3.49977 14.2761 3.27591 14.5 2.99977 14.5C2.91931 14.5 2.8453 14.4815 2.7798 14.4493C2.50461 14.314 2.17475 14.3598 1.94686 14.565C1.71898 14.7702 1.639 15.0935 1.7449 15.3813C2.30692 16.9087 3.77495 18 5.49977 18C7.70742 18 9.49735 16.2113 9.49977 14.0042L9.49977 14C9.49977 13.52 9.38647 13.0642 9.18446 12.6601C8.89396 12.0789 8.42089 11.6058 7.83969 11.3153C7.43554 11.1133 6.97981 11 6.49977 11Z"
        fill={color}
      />
    </svg>
  )
}

export const PhotoIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 5.25C1.5 4.00736 2.50736 3 3.75 3H17.25C18.4926 3 19.5 4.00736 19.5 5.25V14.75C19.5 15.9926 18.4926 17 17.25 17H3.75C2.50736 17 1.5 15.9926 1.5 14.75V5.25ZM3 11.0607V14.75C3 15.1642 3.33579 15.5 3.75 15.5H17.25C17.6642 15.5 18 15.1642 18 14.75V12.0607L15.7803 9.84099C15.4874 9.5481 15.0126 9.5481 14.7197 9.84099L12.8107 11.75L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L7.03033 8.09099C6.73744 7.7981 6.26256 7.7981 5.96967 8.09099L3 11.0607ZM12.5 7C12.5 7.55228 12.0523 8 11.5 8C10.9477 8 10.5 7.55228 10.5 7C10.5 6.44772 10.9477 6 11.5 6C12.0523 6 12.5 6.44772 12.5 7Z"
        fill={color}
      />
    </svg>
  )
}

export const SocialMediaIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0847 3.41529C15.8643 2.1949 13.8857 2.1949 12.6653 3.41529L8.91529 7.16529C7.6949 8.38568 7.6949 10.3643 8.91529 11.5847C9.17435 11.8438 9.46648 12.0471 9.77752 12.1957C10.089 12.3445 10.2209 12.7176 10.0721 13.0291C9.92328 13.3405 9.55018 13.4724 9.23871 13.3236C8.80141 13.1147 8.39219 12.8294 8.03141 12.4686C6.32286 10.76 6.32286 7.98995 8.03141 6.28141L11.7814 2.53141C13.49 0.822864 16.26 0.822864 17.9686 2.53141C19.6771 4.23995 19.6771 7.01005 17.9686 8.71859L16.5044 10.1827C16.2604 10.4268 15.8646 10.4268 15.6206 10.1827C15.3765 9.93866 15.3765 9.54293 15.6206 9.29885L17.0847 7.83471C18.3051 6.61432 18.3051 4.63568 17.0847 3.41529ZM10.9279 6.97094C11.0767 6.65948 11.4498 6.52761 11.7613 6.67639C12.1986 6.8853 12.6078 7.17062 12.9686 7.53141C14.6771 9.23995 14.6771 12.01 12.9686 13.7186L9.21859 17.4686C7.51005 19.1771 4.73995 19.1771 3.03141 17.4686C1.32286 15.76 1.32286 12.99 3.03141 11.2814L4.49555 9.81727C4.73963 9.57319 5.13536 9.57319 5.37943 9.81727C5.62351 10.0613 5.62351 10.4571 5.37943 10.7011L3.91529 12.1653C2.6949 13.3857 2.6949 15.3643 3.91529 16.5847C5.13568 17.8051 7.11432 17.8051 8.33471 16.5847L12.0847 12.8347C13.3051 11.6143 13.3051 9.63568 12.0847 8.41529C11.8257 8.15623 11.5335 7.95289 11.2225 7.80431C10.911 7.65552 10.7791 7.28241 10.9279 6.97094Z"
        fill={color}
      />
    </svg>
  )
}

export const TargetIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4981 1.66504C11.5014 1.66504 12.4631 1.84254 13.3539 2.16671L12.3581 3.16171C10.851 2.7519 9.25077 2.85155 7.80618 3.44516C6.36159 4.03877 5.15363 5.09306 4.37012 6.4441C3.5866 7.79514 3.27146 9.36721 3.47369 10.9159C3.67592 12.4645 4.38418 13.9029 5.48835 15.0075C6.59252 16.112 8.03072 16.8208 9.57929 17.0235C11.1279 17.2263 12.7 16.9116 14.0513 16.1286C15.4027 15.3455 16.4574 14.1379 17.0514 12.6935C17.6455 11.2491 17.7457 9.64891 17.3364 8.14171L18.3314 7.14671C18.6642 8.06116 18.834 9.02691 18.8331 10C18.8331 14.6034 15.1014 18.335 10.4981 18.335C5.89475 18.335 2.16309 14.6034 2.16309 10C2.16309 5.39671 5.89475 1.66504 10.4981 1.66504ZM10.4981 5.00004C10.9203 4.99984 11.3409 5.05304 11.7498 5.15837V6.46421C10.9479 6.18051 10.0734 6.17786 9.26978 6.45667C8.4662 6.73549 7.78127 7.27922 7.32743 7.9986C6.87359 8.71799 6.67779 9.5703 6.77218 10.4156C6.86658 11.261 7.24554 12.0491 7.84689 12.6506C8.44823 13.2522 9.23622 13.6315 10.0815 13.7262C10.9268 13.8209 11.7792 13.6254 12.4987 13.1718C13.2183 12.7182 13.7623 12.0335 14.0414 11.23C14.3205 10.4265 14.3182 9.55202 14.0348 8.75004H15.3406C15.6013 9.75971 15.5398 10.8256 15.1647 11.7986C14.7896 12.7716 14.1196 13.603 13.2486 14.1763C12.3776 14.7497 11.3491 15.0364 10.3071 14.9963C9.26512 14.9563 8.26171 14.5914 7.43734 13.9528C6.61297 13.3142 6.00889 12.4338 5.70965 11.4349C5.41041 10.4359 5.43098 9.36843 5.76848 8.38177C6.10598 7.39511 6.74352 6.53866 7.59188 5.93229C8.44024 5.32591 9.45696 4.99996 10.4998 5.00004H10.4981ZM12.1648 10C12.1646 10.3583 12.0491 10.7069 11.8353 10.9943C11.6215 11.2817 11.3208 11.4926 10.9777 11.5957C10.6346 11.6988 10.2675 11.6886 9.93066 11.5666C9.59385 11.4446 9.30528 11.2174 9.10774 10.9186C8.9102 10.6198 8.8142 10.2652 8.83396 9.90757C8.85371 9.5499 8.98818 9.20812 9.21744 8.93286C9.44669 8.65761 9.75852 8.46355 10.1067 8.37944C10.4549 8.29532 10.821 8.32563 11.1506 8.46587L12.5839 7.03254L12.5831 4.37504C12.5832 4.20933 12.6492 4.05047 12.7664 3.93337L14.8498 1.85004C14.9372 1.76274 15.0485 1.7033 15.1696 1.67923C15.2908 1.65516 15.4164 1.66754 15.5305 1.7148C15.6447 1.76206 15.7422 1.84208 15.8109 1.94476C15.8796 2.04744 15.9163 2.16817 15.9164 2.29171V4.58337H18.2081C18.3316 4.58348 18.4523 4.6202 18.555 4.68888C18.6577 4.75756 18.7377 4.85513 18.785 4.96927C18.8323 5.08341 18.8446 5.20899 18.8206 5.33015C18.7965 5.45132 18.737 5.56263 18.6498 5.65004L16.5664 7.73337C16.4493 7.85062 16.2905 7.91656 16.1248 7.91671H13.4664L12.0331 9.35004C12.1181 9.55004 12.1648 9.76921 12.1648 10ZM15.8656 6.66671L16.6989 5.83337H15.2906C15.1248 5.83337 14.9659 5.76752 14.8486 5.65031C14.7314 5.5331 14.6656 5.37413 14.6656 5.20837V3.80004L13.8331 4.63337V6.61754C13.8505 6.63321 13.8669 6.6499 13.8823 6.66754H15.8656V6.66671Z"
        fill={color}
      />
    </svg>
  )
}

export const CarIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 1.75C1.5 1.33579 1.83579 1 2.25 1H3.87846C4.75256 1 5.49261 1.64498 5.61205 2.51088L5.67955 3.00024C10.2591 3.01263 14.7281 3.49872 19.0398 4.41236C19.4395 4.49706 19.6979 4.88613 19.6209 5.2874C19.2145 7.40548 18.6717 9.47515 18.002 11.4869C17.9 11.7933 17.6134 12 17.2904 12H6.5C6.38567 12 6.27351 12.0076 6.16393 12.0223C5.28545 12.14 4.55092 12.7153 4.20796 13.5H17.75C18.1642 13.5 18.5 13.8358 18.5 14.25C18.5 14.6642 18.1642 15 17.75 15H3.25948C3.05068 15 2.85133 14.913 2.7094 14.7598C2.56747 14.6067 2.4958 14.4013 2.51164 14.1931C2.63566 12.5628 3.73526 11.2069 5.22829 10.7066L4.12612 2.71584C4.10906 2.59214 4.00333 2.5 3.87846 2.5H2.25C1.83579 2.5 1.5 2.16421 1.5 1.75Z"
        fill={color}
      />
      <path
        d="M6.5 17.5C6.5 18.3284 5.82843 19 5 19C4.17157 19 3.5 18.3284 3.5 17.5C3.5 16.6716 4.17157 16 5 16C5.82843 16 6.5 16.6716 6.5 17.5Z"
        fill={color}
      />
      <path
        d="M16 19C16.8284 19 17.5 18.3284 17.5 17.5C17.5 16.6716 16.8284 16 16 16C15.1716 16 14.5 16.6716 14.5 17.5C14.5 18.3284 15.1716 19 16 19Z"
        fill={color}
      />
    </svg>
  )
}

export const ChatIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5403 2.30917C6.48585 2.02311 8.47594 1.875 10.5002 1.875C12.5244 1.875 14.5143 2.02308 16.4597 2.30909C18.1083 2.55147 19.25 3.99537 19.25 5.61713V10.6329C19.25 12.2546 18.1083 13.6985 16.4596 13.9409C15.5045 14.0813 14.5386 14.1885 13.5632 14.2612C13.4595 14.269 13.3692 14.3229 13.3159 14.4029L11.02 17.8467C10.9041 18.0206 10.709 18.125 10.5 18.125C10.291 18.125 10.0959 18.0206 9.97997 17.8467L7.6841 14.4029C7.63075 14.3229 7.54044 14.2689 7.43673 14.2612C6.46132 14.1885 5.49543 14.0813 4.5403 13.9408C2.8917 13.6984 1.75 12.2545 1.75 10.6328V5.6172C1.75 3.99546 2.8917 2.55157 4.5403 2.30917ZM6.125 6.875C6.125 6.52982 6.40482 6.25 6.75 6.25H14.25C14.5952 6.25 14.875 6.52982 14.875 6.875C14.875 7.22018 14.5952 7.5 14.25 7.5H6.75C6.40482 7.5 6.125 7.22018 6.125 6.875ZM6.75 8.75C6.40482 8.75 6.125 9.02982 6.125 9.375C6.125 9.72018 6.40482 10 6.75 10H10.5C10.8452 10 11.125 9.72018 11.125 9.375C11.125 9.02982 10.8452 8.75 10.5 8.75H6.75Z"
        fill={color}
      />
    </svg>
  )
}

export const ImageListIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75 5.9375C1.75 5.07456 2.44956 4.375 3.3125 4.375H8.3125C9.17544 4.375 9.875 5.07456 9.875 5.9375V9.0625C9.875 9.92545 9.17544 10.625 8.3125 10.625H3.3125C2.44956 10.625 1.75 9.92544 1.75 9.0625V5.9375ZM11.75 7.1875C11.75 6.32456 12.4496 5.625 13.3125 5.625H17.6875C18.5504 5.625 19.25 6.32456 19.25 7.1875V14.0625C19.25 14.9254 18.5504 15.625 17.6875 15.625H13.3125C12.4496 15.625 11.75 14.9254 11.75 14.0625V7.1875ZM3 13.4375C3 12.5746 3.69956 11.875 4.5625 11.875H8.9375C9.80044 11.875 10.5 12.5746 10.5 13.4375V15.3125C10.5 16.1754 9.80044 16.875 8.9375 16.875H4.5625C3.69955 16.875 3 16.1754 3 15.3125V13.4375Z"
        fill={color}
      />
    </svg>
  )
}

export const ArchetypeIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 6C1.5 4.34315 2.84315 3 4.5 3H16.5C18.1569 3 19.5 4.34315 19.5 6V14C19.5 15.6569 18.1569 17 16.5 17H4.5C2.84315 17 1.5 15.6569 1.5 14V6ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.49987 10.5C5.86027 10.5 4.45272 11.4864 3.8351 12.895C3.75293 13.0824 3.7509 13.2952 3.82946 13.4842C3.90802 13.6731 4.06036 13.8217 4.25117 13.8956C5.25988 14.2862 6.35579 14.5 7.49987 14.5C8.64395 14.5 9.73987 14.2862 10.7486 13.8956C10.9394 13.8217 11.0917 13.6731 11.1703 13.4842C11.2488 13.2952 11.2468 13.0824 11.1647 12.895C10.547 11.4864 9.13947 10.5 7.49987 10.5ZM12.5 6.75C12.5 6.33579 12.8358 6 13.25 6H15.75C16.1642 6 16.5 6.33579 16.5 6.75C16.5 7.16421 16.1642 7.5 15.75 7.5H13.25C12.8358 7.5 12.5 7.16421 12.5 6.75ZM12.5 13.25C12.5 12.8358 12.8358 12.5 13.25 12.5H15.75C16.1642 12.5 16.5 12.8358 16.5 13.25C16.5 13.6642 16.1642 14 15.75 14H13.25C12.8358 14 12.5 13.6642 12.5 13.25ZM13.25 9.25C12.8358 9.25 12.5 9.58579 12.5 10C12.5 10.4142 12.8358 10.75 13.25 10.75L15.75 10.75C16.1642 10.75 16.5 10.4142 16.5 10C16.5 9.58579 16.1642 9.25 15.75 9.25L13.25 9.25Z"
        fill={color}
      />
    </svg>
  )
}

export const PreferencesIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83922 1.80388C8.93271 1.33646 9.34312 1 9.8198 1H11.1802C11.6569 1 12.0673 1.33646 12.1608 1.80388L12.4553 3.27675C12.9522 3.42101 13.4263 3.61886 13.8709 3.86363L15.1212 3.03014C15.5178 2.76572 16.0459 2.81802 16.383 3.15508L17.3449 4.11702C17.682 4.45409 17.7343 4.98221 17.4699 5.37883L16.6364 6.62908C16.8811 7.07369 17.079 7.54778 17.2232 8.04465L18.6961 8.33922C19.1635 8.43271 19.5 8.84312 19.5 9.3198V10.6802C19.5 11.1569 19.1635 11.5673 18.6961 11.6608L17.2232 11.9553C17.079 12.4522 16.8812 12.9262 16.6364 13.3708L17.47 14.6212C17.7344 15.0178 17.6821 15.5459 17.345 15.883L16.3831 16.8449C16.046 17.182 15.5179 17.2343 15.1213 16.9699L13.871 16.1363C13.4264 16.3811 12.9522 16.579 12.4554 16.7232L12.1608 18.1961C12.0673 18.6635 11.6569 19 11.1802 19H9.8198C9.34312 19 8.93271 18.6635 8.83922 18.1961L8.54465 16.7232C8.04778 16.579 7.5737 16.3811 7.12908 16.1364L5.87882 16.9699C5.4822 17.2343 4.95408 17.182 4.61701 16.8449L3.65507 15.883C3.31801 15.5459 3.26571 15.0178 3.53013 14.6212L4.36363 13.3709C4.11886 12.9263 3.92101 12.4522 3.77675 11.9554L2.30388 11.6608C1.83646 11.5673 1.5 11.1569 1.5 10.6802L1.5 9.3198C1.5 8.84312 1.83646 8.43271 2.30388 8.33922L3.77675 8.04465C3.92102 7.54774 4.11889 7.07363 4.36368 6.62898L3.53024 5.37882C3.26582 4.9822 3.31812 4.45408 3.65518 4.11701L4.61712 3.15507C4.95419 2.81801 5.48231 2.76571 5.87893 3.03013L7.12913 3.86359C7.57373 3.61884 8.0478 3.42101 8.54465 3.27675L8.83922 1.80388ZM13.5 10C13.5 11.6569 12.1569 13 10.5 13C8.84315 13 7.5 11.6569 7.5 10C7.5 8.34315 8.84315 7 10.5 7C12.1569 7 13.5 8.34315 13.5 10Z"
        fill={color}
      />
    </svg>
  )
}

export const PinterestIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3 26.925C12.5 27.2875 13.7125 27.5 15 27.5C18.3152 27.5 21.4946 26.183 23.8388 23.8388C26.183 21.4946 27.5 18.3152 27.5 15C27.5 13.3585 27.1767 11.733 26.5485 10.2165C25.9203 8.69989 24.9996 7.3219 23.8388 6.16117C22.6781 5.00043 21.3001 4.07969 19.7835 3.45151C18.267 2.82332 16.6415 2.5 15 2.5C13.3585 2.5 11.733 2.82332 10.2165 3.45151C8.69989 4.07969 7.3219 5.00043 6.16117 6.16117C3.81696 8.50537 2.5 11.6848 2.5 15C2.5 20.3125 5.8375 24.875 10.55 26.675C10.4375 25.7 10.325 24.0875 10.55 22.975L11.9875 16.8C11.9875 16.8 11.625 16.075 11.625 14.925C11.625 13.2 12.7 11.9125 13.925 11.9125C15 11.9125 15.5 12.7 15.5 13.7125C15.5 14.7875 14.7875 16.325 14.425 17.8C14.2125 19.025 15.075 20.1 16.325 20.1C18.55 20.1 20.275 17.725 20.275 14.375C20.275 11.375 18.125 9.325 15.0375 9.325C11.5125 9.325 9.4375 11.95 9.4375 14.7125C9.4375 15.7875 9.7875 16.875 10.3625 17.5875C10.475 17.6625 10.475 17.7625 10.4375 17.95L10.075 19.3125C10.075 19.525 9.9375 19.6 9.725 19.45C8.125 18.75 7.2 16.475 7.2 14.6375C7.2 10.6875 10 7.1 15.4 7.1C19.7 7.1 23.05 10.1875 23.05 14.2875C23.05 18.5875 20.3875 22.0375 16.575 22.0375C15.3625 22.0375 14.175 21.3875 13.75 20.625L12.9125 23.5875C12.625 24.6625 11.8375 26.1 11.3 26.9625V26.925Z"
        fill={color}
      />
    </svg>
  )
}

export const LinkedlnIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 0.75C21.413 0.75 22.0489 1.01339 22.5178 1.48223C22.9866 1.95107 23.25 2.58696 23.25 3.25V20.75C23.25 21.413 22.9866 22.0489 22.5178 22.5178C22.0489 22.9866 21.413 23.25 20.75 23.25H3.25C2.58696 23.25 1.95107 22.9866 1.48223 22.5178C1.01339 22.0489 0.75 21.413 0.75 20.75V3.25C0.75 2.58696 1.01339 1.95107 1.48223 1.48223C1.95107 1.01339 2.58696 0.75 3.25 0.75H20.75ZM20.125 20.125V13.5C20.125 12.4192 19.6957 11.3828 18.9315 10.6185C18.1672 9.85433 17.1308 9.425 16.05 9.425C14.9875 9.425 13.75 10.075 13.15 11.05V9.6625H9.6625V20.125H13.15V13.9625C13.15 13 13.925 12.2125 14.8875 12.2125C15.3516 12.2125 15.7967 12.3969 16.1249 12.7251C16.4531 13.0533 16.6375 13.4984 16.6375 13.9625V20.125H20.125ZM5.6 7.7C6.15695 7.7 6.6911 7.47875 7.08492 7.08492C7.47875 6.6911 7.7 6.15695 7.7 5.6C7.7 4.4375 6.7625 3.4875 5.6 3.4875C5.03973 3.4875 4.50241 3.71007 4.10624 4.10624C3.71007 4.50241 3.4875 5.03973 3.4875 5.6C3.4875 6.7625 4.4375 7.7 5.6 7.7ZM7.3375 20.125V9.6625H3.875V20.125H7.3375Z"
        fill={color}
      />
    </svg>
  )
}

export const FacebookIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.5 15C27.5 8.1 21.9 2.5 15 2.5C8.1 2.5 2.5 8.1 2.5 15C2.5 21.05 6.8 26.0875 12.5 27.25V18.75H10V15H12.5V11.875C12.5 9.4625 14.4625 7.5 16.875 7.5H20V11.25H17.5C16.8125 11.25 16.25 11.8125 16.25 12.5V15H20V18.75H16.25V27.4375C22.5625 26.8125 27.5 21.4875 27.5 15Z"
        fill={color}
      />
    </svg>
  )
}

export const InstagramIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.75 0.5H18.25C22.25 0.5 25.5 3.75 25.5 7.75V18.25C25.5 20.1728 24.7362 22.0169 23.3765 23.3765C22.0169 24.7362 20.1728 25.5 18.25 25.5H7.75C3.75 25.5 0.5 22.25 0.5 18.25V7.75C0.5 5.82718 1.26384 3.98311 2.62348 2.62348C3.98311 1.26384 5.82718 0.5 7.75 0.5ZM7.5 3C6.30653 3 5.16193 3.47411 4.31802 4.31802C3.47411 5.16193 3 6.30653 3 7.5V18.5C3 20.9875 5.0125 23 7.5 23H18.5C19.6935 23 20.8381 22.5259 21.682 21.682C22.5259 20.8381 23 19.6935 23 18.5V7.5C23 5.0125 20.9875 3 18.5 3H7.5ZM19.5625 4.875C19.9769 4.875 20.3743 5.03962 20.6674 5.33265C20.9604 5.62567 21.125 6.0231 21.125 6.4375C21.125 6.8519 20.9604 7.24933 20.6674 7.54235C20.3743 7.83538 19.9769 8 19.5625 8C19.1481 8 18.7507 7.83538 18.4576 7.54235C18.1646 7.24933 18 6.8519 18 6.4375C18 6.0231 18.1646 5.62567 18.4576 5.33265C18.7507 5.03962 19.1481 4.875 19.5625 4.875ZM13 6.75C14.6576 6.75 16.2473 7.40848 17.4194 8.58058C18.5915 9.75268 19.25 11.3424 19.25 13C19.25 14.6576 18.5915 16.2473 17.4194 17.4194C16.2473 18.5915 14.6576 19.25 13 19.25C11.3424 19.25 9.75268 18.5915 8.58058 17.4194C7.40848 16.2473 6.75 14.6576 6.75 13C6.75 11.3424 7.40848 9.75268 8.58058 8.58058C9.75268 7.40848 11.3424 6.75 13 6.75ZM13 9.25C12.0054 9.25 11.0516 9.64509 10.3483 10.3483C9.64509 11.0516 9.25 12.0054 9.25 13C9.25 13.9946 9.64509 14.9484 10.3483 15.6517C11.0516 16.3549 12.0054 16.75 13 16.75C13.9946 16.75 14.9484 16.3549 15.6517 15.6517C16.3549 14.9484 16.75 13.9946 16.75 13C16.75 12.0054 16.3549 11.0516 15.6517 10.3483C14.9484 9.64509 13.9946 9.25 13 9.25Z"
        fill={color}
      />
    </svg>
  )
}

export const TikTokIcon = ({ color }) => {
  if (!color) color = '#fff'

  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7492 4.275C14.8947 3.29953 14.4239 2.04679 14.4242 0.75H10.5617V16.25C10.5319 17.0888 10.1778 17.8833 9.57393 18.4662C8.97004 19.0491 8.16353 19.3749 7.32422 19.375C5.54922 19.375 4.07422 17.925 4.07422 16.125C4.07422 13.975 6.14922 12.3625 8.28672 13.025V9.075C3.97422 8.5 0.199219 11.85 0.199219 16.125C0.199219 20.2875 3.64922 23.25 7.31172 23.25C11.2367 23.25 14.4242 20.0625 14.4242 16.125V8.2625C15.9905 9.38731 17.8709 9.99081 19.7992 9.9875V6.125C19.7992 6.125 17.4492 6.2375 15.7492 4.275Z"
        fill={color}
      />
    </svg>
  )
}
